import { render, staticRenderFns } from "./VideosList.vue?vue&type=template&id=3db62fb4&scoped=true&"
import script from "./VideosList.vue?vue&type=script&lang=ts&"
export * from "./VideosList.vue?vue&type=script&lang=ts&"
import style0 from "./VideosList.vue?vue&type=style&index=0&id=3db62fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db62fb4",
  null
  
)

export default component.exports